import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Base from './Base';

const User = forwardRef(({ selectedNav, index, auth }, ref) => {
    return (
        <div>
            <Base ref={ref} index={index} selectedNav={selectedNav}>
                <div className="megamenu">
                    <div className="megamenu-columns">
                        <div className="primary-columns">
                            <h2>Accounts</h2>
                            <div className="columns-2">
                                <div className="primary-column">
                                    <h3>Manage Users</h3>
                                    <Link to="/u/users/all">
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-solid fa-user" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>List Users</h4>
                                                <p className="link-subtext">
                                                    List all Users
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="grid-link-container">
                                        <Link
                                            to="/u/users/all/grid-edit"
                                            className="grid-link"
                                        >
                                            Grid Edit
                                        </Link>
                                        <Link
                                            to="/u/users/all/create"
                                            className="grid-link"
                                        >
                                            Create
                                        </Link>
                                    </div>
                                    <h3>Manage Drivers</h3>
                                    <Link to="/u/users/all?role=driver">
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-solid fa-cat" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>List Drivers</h4>

                                                <p className="link-subtext">
                                                    List all Drivers
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="primary-column">
                                    <h3>Manage Clients</h3>
                                    <Link to="/c/clients/all">
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-brands fa-cuttlefish" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>List Clients</h4>
                                                <p className="link-subtext">
                                                    List all Clients
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="grid-link-container">
                                        <Link
                                            to="/c/clients/all/grid-edit"
                                            className="grid-link"
                                        >
                                            Grid Edit
                                        </Link>
                                        <Link
                                            to="/c/clients/all/create"
                                            className="grid-link"
                                        >
                                            Create
                                        </Link>
                                    </div>

                                    {auth?.user?.role === 'admin' && (
                                        <Link to="/ctr/contractors/all">
                                            <div className="megamenu-link">
                                                <div className="logo-wrapper">
                                                    <div className="megamenu-icon">
                                                        <i className="fa-solid fa-cat" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <h4>List Contractors</h4>
                                                    <p className="link-subtext">
                                                        List all Contractors
                                                    </p>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="secondary-columns">
                            <ul></ul>
                        </div>
                    </div>
                </div>
            </Base>
        </div>
    );
});

User.displayName = 'User';
User.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.shape({ role: PropTypes.string }),
    }),
    index: PropTypes.number,
    selectedNav: PropTypes.number,
};

export default User;
